import { __read, __assign } from '../../node_modules/tslib/tslib.es6.esm.js';
import React__default, { createContext, useState, useRef, useCallback, useEffect } from 'react';
import { kebabCase, noop } from 'lodash';
import { useQueryObject } from '@invitae/react-hooks';

var NvTabsContext = createContext({});
var NvTabsContextProvider = function (_a) {
    var children = _a.children, defaultTabId = _a.defaultTabId, onTabChange = _a.onTabChange, withSearchParamsControl = _a.withSearchParamsControl, _b = _a.id, id = _b === void 0 ? '' : _b, _c = _a.pathname, pathname = _c === void 0 ? '' : _c, _d = _a.onRoutePush, onRoutePush = _d === void 0 ? noop : _d, currentTabId = _a.currentTabId, _e = _a.searchParam, searchParam = _e === void 0 ? '' : _e, tabsMap = _a.tabsMap;
    var urlSearchParams = new URLSearchParams(searchParam);
    var tabParamSelected = urlSearchParams.get(id);
    var _f = __read(useState(), 2), currentTab = _f[0], setCurrentTab = _f[1];
    var _g = __read(useState(), 2), lastTabId = _g[0], setLastTabId = _g[1];
    var firstRender = useRef(true);
    var _h = useQueryObject(pathname, onRoutePush), queryObject = _h.queryObject, setQueryObject = _h.setQueryObject;
    var selectTab = useCallback(function (currentTabId, execOnTabChange) {
        if (execOnTabChange === void 0) { execOnTabChange = true; }
        var tabId = kebabCase(currentTabId);
        if ((queryObject === null || queryObject === void 0 ? void 0 : queryObject[id]) === tabId)
            return;
        setCurrentTab(tabId);
        if (execOnTabChange) {
            onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(tabId, { lastTabId: lastTabId, tabId: currentTabId, title: tabsMap === null || tabsMap === void 0 ? void 0 : tabsMap[currentTabId] });
        }
        if (withSearchParamsControl) {
            setQueryObject(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[id] = tabId, _a)));
            });
        }
        setLastTabId(tabId);
    }, [id, onTabChange, setQueryObject, withSearchParamsControl, queryObject, lastTabId, tabsMap]);
    var isTabOnTheMap = useCallback(function (tabParam) {
        return !!Object.keys(__assign({}, (tabsMap || {}))).find(function (key) { return kebabCase(key) === kebabCase(tabParam); });
    }, [tabsMap]);
    useEffect(function () {
        currentTabId && selectTab(currentTabId, false);
    }, [currentTabId, selectTab]);
    useEffect(function () {
        if (!firstRender.current)
            return;
        var initialState = defaultTabId;
        if (tabsMap && !initialState) {
            initialState = Object.keys(tabsMap)[0];
        }
        if (withSearchParamsControl && tabParamSelected && isTabOnTheMap(tabParamSelected)) {
            initialState = tabParamSelected;
        }
        if (!initialState)
            return;
        selectTab(initialState, false);
        firstRender.current = false;
    }, [defaultTabId, selectTab, tabParamSelected, withSearchParamsControl, isTabOnTheMap, tabsMap]);
    return currentTab ? React__default.createElement(NvTabsContext.Provider, { value: { currentTab: currentTab, selectTab: selectTab } }, children) : null;
};

export { NvTabsContext, NvTabsContextProvider };
//# sourceMappingURL=NvTabsContext.esm.js.map
